/**
 * src/domains/jobs/jobs.api.ts
 *
 * All API calls for marketplace jobs.
 * Components must never call fetch() directly — use these functions.
 */
import { apiClient } from '../../infra/api/apiClient';

import type { Job, CreateJobPayload } from './jobs.types';

export async function fetchOpenJobs(category?: string): Promise<Job[]> {
  const query = category ? `?category=${encodeURIComponent(category)}` : '';
  return apiClient.get<Job[]>(`/marketplace/jobs${query}`);
}

export async function fetchMyJobs(): Promise<Job[]> {
  return apiClient.get<Job[]>('/marketplace/jobs/mine');
}

export async function fetchJob(id: string): Promise<Job> {
  return apiClient.get<Job>(`/marketplace/jobs/${id}`);
}

export async function createJob(data: CreateJobPayload): Promise<Job> {
  return apiClient.post<Job>('/marketplace/jobs', data);
}

export async function updateJob(id: string, data: Partial<CreateJobPayload>): Promise<Job> {
  return apiClient.put<Job>(`/marketplace/jobs/${id}`, data);
}

export async function toggleJobStatus(id: string, status: 'open' | 'closed'): Promise<Job> {
  return apiClient.patch<Job>(`/marketplace/jobs/${id}/status`, { status });
}
